import { useState } from 'react';

/**
 * Custom hook for managing loan term with automatic interest rate updates
 * When loan term changes, automatically updates interest rate from currentRates if available
 *
 * @param {number} initialTerm - Initial loan term in years (default: 30)
 * @param {Object} currentRates - Current rates object keyed by term (e.g., {15: 5.5, 30: 6.42})
 * @param {Function} setInterestRate - Function to update interest rate from parent
 * @returns {Object} State value and handler
 */
const useLoanTerm = (initialTerm = 30, currentRates = null, setInterestRate = null) => {
  const [loanTerm, setLoanTerm] = useState(initialTerm);

  /**
   * Handle loan term changes
   * Automatically updates interest rate if currentRates are available
   */
  const handleLoanTermChange = (value) => {
    const termValue = parseInt(value);
    setLoanTerm(termValue);

    // Auto-update interest rate if we have current rates and a setter
    if (currentRates && currentRates[value] && setInterestRate) {
      setInterestRate(currentRates[value]);
    }
  };

  return {
    loanTerm,
    handleLoanTermChange,
    setLoanTerm
  };
};

export default useLoanTerm;
